import Ice1Src from '../../shared/assets/images/obstacles/ice-1.svg';
import Ice2Src from '../../shared/assets/images/obstacles/ice-2.svg';
import Ice3Src from '../../shared/assets/images/obstacles/ice-3.svg';
import BearSrc from '../../shared/assets/images/obstacles/bear-1.svg';
import SealSrc from '../../shared/assets/images/obstacles/seal.svg';
import WhaleSrc from '../../shared/assets/images/obstacles/whale.svg';

const windowApp = document.getElementById('app-window');
let windowWidth = windowApp ? windowApp.offsetWidth : 375;
let windowHeight = windowApp ? windowApp.offsetHeight : 667;

export function Player(x, y, image) {
  this.position = {
    x: x,
    y: y,
  };
  this.velocity = {
    x: 0,
    y: -1,
  };
  this.image = image;
  this.width = 20;
  this.height = 104;
  this.angle = 0;
  this.headPosition = { x: 0, y: 0 };
  this.assPosition = { x: 0, y: 0 };

  this.draw = (c) => {
    c.save(); // Сохраняем текущее состояние контекста
    c.translate(this.position.x, this.position.y); // Переносим точку вращения в центр корабля
    c.rotate(this.angle);
    c.drawImage(
      this.image,
      Math.floor(-this.width / 2),
      Math.floor(-this.height / 2),
      Math.floor(this.width),
      Math.floor(this.height),
    ); // Рисуем изображение
    c.restore(); // Восстанавливаем предыдущее состояние контекста
  };

  this.update = (c) => {
    this.position.x += this.velocity.x;
    this.position.y += this.velocity.y;

    this.headPosition = {
      x: this.position.x + (this.height / 2) * Math.sin(this.angle),
      y: this.position.y - (this.height / 2) * Math.cos(this.angle),
    };
    this.assPosition = {
      x: this.position.x - (this.height / 2) * Math.sin(this.angle),
      y: this.position.y + (this.height / 2) * Math.cos(this.angle),
    };
    // this.draw(c);
  };
}

export function Ship2(x, y, image) {
  this.position = {
    x: x,
    y: y,
  };
  this.velocity = {
    x: 0,
    y: -1,
  };
  this.image = image;
  this.width = 20;
  this.height = 104;
  this.angle = 0;
  this.headPosition = { x: 0, y: 0 };
  this.assPosition = { x: 0, y: 0 };
  this.sidesPoints = [
    { x: 0, y: 0 },
    { x: 0, y: 0 },
  ];

  this.draw = (c) => {
    c.save(); // Сохраняем текущее состояние контекста
    c.translate(this.position.x, this.position.y); // Переносим точку вращения в центр корабля
    c.rotate(this.angle);
    c.drawImage(
      this.image,
      Math.floor(-this.width / 2),
      Math.floor(-this.height / 2),
      Math.floor(this.width),
      Math.floor(this.height),
    ); // Рисуем изображение
    c.restore(); // Восстанавливаем предыдущее состояние контекста
  };

  this.update = (c) => {
    this.position.x += this.velocity.x;
    this.position.y += this.velocity.y;

    this.sidesPoints = [
      {
        x: this.position.x + ((-this.height + 20) / 2) * Math.sin(this.angle - 0.2),
        y: this.position.y - ((-this.height + 20) / 2) * Math.cos(this.angle - 0.2),
      },
      {
        x: this.position.x + ((-this.height + 20) / 2) * Math.sin(this.angle + 0.2),
        y: this.position.y - ((-this.height + 20) / 2) * Math.cos(this.angle + 0.2),
      },
    ];

    this.headPosition = {
      x: this.position.x + (this.height / 2) * Math.sin(this.angle),
      y: this.position.y - (this.height / 2) * Math.cos(this.angle),
    };
    this.assPosition = {
      x: this.position.x - (this.height / 2) * Math.sin(this.angle),
      y: this.position.y + (this.height / 2) * Math.cos(this.angle),
    };
    // this.draw(c);
  };
}

export function Trail(coordinates, image) {
  this.position = {
    x: 0,
    y: 0,
  };
  this.coordinates = coordinates;
  this.image = image;

  this.updateTrail = () => {
    // Определяем значение, которое будет добавляться к координатам в зависимости от расстояния
    const distanceMultiplier = 0.03; // Множитель, регулирующий величину изменений

    // Разделяем массив пополам
    const middleIndex = Math.floor(this.coordinates.length / 2);

    // Добавляем к первой половине массива
    for (let i = 0; i < middleIndex; i++) {
      this.coordinates[i].x -= distanceMultiplier;
    }

    // Убавляем от второй половины массива
    for (let i = middleIndex; i < this.coordinates.length; i++) {
      this.coordinates[i].x += distanceMultiplier;
    }
    // if (middleIndex > 500) {
    //   this.coordinates.splice(middleIndex / 2 - 1, 1);
    //   this.coordinates.splice(middleIndex / 2 + 2, 1);
    // }
  };

  this.draw = (c) => {
    c.beginPath();
    c.moveTo(this.position.x + this.coordinates[0].x, this.position.y + this.coordinates[0].y);
    for (let i = 1; i < this.coordinates.length; i++) {
      c.lineTo(this.position.x + this.coordinates[i].x, this.position.y + this.coordinates[i].y);
    }
    c.closePath();
    // Заполняем полигон картинкой
    const pattern = c.createPattern(this.image, 'repeat');
    c.save();
    c.translate(this.position.x, this.position.y);
    c.fillStyle = pattern;
    c.fill();
    c.restore();
    // c.strokeStyle = '#0a2356';
    // c.stroke();
  };
  this.update = (c) => {
    this.updateTrail();
    this.draw(c);
  };
}

export function Background(x, y, image) {
  this.position = {
    x: x,
    y: y,
  };
  this.image = image;
  this.width = 1248;
  this.height = 2106;

  this.draw = (c) => {
    c.drawImage(this.image, this.position.x, this.position.y, this.width, this.height);
  };
}

export function Trajectory(coordinates, windowWidth, windowHeight) {
  this.position = {
    x: windowWidth / 2 - (1920 * 0.65) / 2,
    y: windowHeight,
  };
  this.coordinates = coordinates;
  this.currentPoints = [];
  this.color = 'red';

  this.draw = (c) => {
    c.beginPath();
    c.moveTo(
      this.position.x + this.coordinates[0].x * 0.65,
      this.position.y - this.coordinates[0].y * 0.65,
    );
    const currentPoint = {
      x: this.position.x + this.coordinates[0].x * 0.65,
      y: this.position.y - this.coordinates[0].y * 0.65,
    };
    this.currentPoints[0] = currentPoint;

    for (let i = 1; i < this.coordinates.length; i++) {
      const point = this.coordinates[i];

      // Вычисляем текущие координаты и добавляем их в массив
      const currentPoint = {
        x: this.position.x + point.x * 0.65,
        y: this.position.y - point.y * 0.65,
      };
      this.currentPoints[i] = currentPoint;

      c.lineTo(this.position.x + point.x * 0.65, this.position.y - point.y * 0.65);
      // c.strokeStyle = '#0a2356';
      // c.stroke();
    }

    c.closePath();
  };
  this.update = (c) => {
    this.draw(c);
  };
}

export function Obstacle(coordinates, image, position, dead) {
  this.position = {
    x: windowWidth / 2 - (1920 * 0.65) / 2 + position.x * 0.65,
    y: windowHeight - 3240 * 0.65 + position.y * 0.65,
  };
  this.image = image;
  this.width = image.width;
  this.height = image.height;
  this.coordinates = coordinates;
  this.currentPoints = [];
  this.deadType = dead;
  this.name = this.width === 93 ? 'ice1' : 'ice2';

  this.drawBorder = (c) => {
    c.beginPath();
    c.moveTo(this.currentPoints[0].x, this.currentPoints[0].y);
    for (let i = 1; i < this.currentPoints.length; i++) {
      const point = this.currentPoints[i];
      c.lineTo(point.x, point.y);
    }
    c.closePath();
    c.strokeStyle = 'red';
    c.stroke();
  };

  this.draw = (c) => {
    c.drawImage(this.image, this.position.x, this.position.y, this.width, this.height);
  };
  this.update = (c) => {
    for (let i = 0; i < this.coordinates.length; i++) {
      const point = this.coordinates[i];
      const currentPoint = {
        x: this.position.x + point.x,
        y: this.position.y + point.y,
      };

      this.currentPoints[i] = currentPoint;
    }
    this.draw(c);
    // this.drawBorder(c);
  };
}

export function ObstacleInBg(coordinates, position, dead) {
  this.position = {
    x: windowWidth / 2 - (1920 * 0.65) / 2 + position.x * 0.65,
    y: windowHeight - 3240 * 0.65 + position.y * 0.65,
  };
  this.coordinates = coordinates;
  this.currentPoints = [];
  this.deadType = dead;

  this.drawBorder = (c) => {
    c.beginPath();
    c.moveTo(this.currentPoints[0].x, this.currentPoints[0].y);
    for (let i = 1; i < this.currentPoints.length; i++) {
      const point = this.currentPoints[i];
      c.lineTo(point.x, point.y);
    }
    c.closePath();
    c.strokeStyle = 'green';
    c.stroke();
  };
  this.update = (c) => {
    for (let i = 0; i < this.coordinates.length; i++) {
      const point = this.coordinates[i];
      const currentPoint = {
        x: this.position.x + point.x * 0.65,
        y: this.position.y + point.y * 0.65,
      };

      this.currentPoints[i] = currentPoint;
    }
    // this.drawBorder(c);
  };
}

// Определение ориентации точки C относительно отрезка AB
function getOrientation(A, B, C) {
  const val = (B.y - A.y) * (C.x - B.x) - (B.x - A.x) * (C.y - B.y);
  if (val === 0) return 0; // Точки коллинеарны
  return val > 0 ? 1 : 2; // 1 - по часовой стрелке, 2 - против часовой стрелки
}

// Проверка, лежит ли точка C на отрезке AB
function isOnSegment(A, B, C) {
  return (
    C.x <= Math.max(A.x, B.x) &&
    C.x >= Math.min(A.x, B.x) &&
    C.y <= Math.max(A.y, B.y) &&
    C.y >= Math.min(A.y, B.y)
  );
}

// Проверка пересечения двух отрезков AB и CD
function doSegmentsIntersect(A, B, C, D) {
  const orientation1 = getOrientation(A, B, C);
  const orientation2 = getOrientation(A, B, D);
  const orientation3 = getOrientation(C, D, A);
  const orientation4 = getOrientation(C, D, B);

  // Отрезки пересекаются, если они имеют разные ориентации по отношению друг к другу
  return (
    (orientation1 !== orientation2 && orientation3 !== orientation4) ||
    (orientation1 === 0 && isOnSegment(A, C, B)) ||
    (orientation2 === 0 && isOnSegment(A, D, B)) ||
    (orientation3 === 0 && isOnSegment(C, A, D)) ||
    (orientation4 === 0 && isOnSegment(C, B, D))
  );
}

// Проверка пересечения отрезка с границей полигона
export function isSegmentIntersectingPolygon(A, B, polygon) {
  const numVertices = polygon.length;

  for (let i = 0; i < numVertices; i++) {
    const vertex1 = polygon[i];
    if (Math.abs(polygon[i].y - A.y) > 200) {
      continue;
    }
    const vertex2 = polygon[(i + 1) % numVertices];

    if (doSegmentsIntersect(A, B, vertex1, vertex2)) {
      return true; // Отрезок пересекает границу полигона
    }
  }

  return false; // Отрезок не пересекает границу полигона
}

export const trajectoryCoordinates = [
  { x: 797, y: 2460 },
  { x: 822, y: 2480 },
  { x: 928, y: 2465 },
  { x: 960, y: 2452 },
  { x: 960, y: 2534 },
  { x: 973, y: 2561 },
  { x: 967, y: 2602 },
  { x: 992, y: 2643 },
  { x: 1007, y: 2633 },
  { x: 1026, y: 2645 },
  { x: 1053, y: 2630 },
  { x: 1065, y: 2640 },
  { x: 1076, y: 2630 },
  { x: 1082, y: 2638 },
  { x: 1093, y: 2627 },
  { x: 1104, y: 2603 },
  { x: 1105, y: 2378 },
  { x: 1084, y: 2358 },
  { x: 984, y: 2342 },
  { x: 980, y: 2302 },
  { x: 988, y: 2261 },
  { x: 957, y: 2216 },
  { x: 950, y: 2180 },
  { x: 947, y: 2100 },
  { x: 970, y: 2044 },
  { x: 971, y: 2003 },
  { x: 956, y: 1985 },
  { x: 960, y: 1953 },
  { x: 973, y: 1933 },
  { x: 973, y: 1896 },
  { x: 960, y: 1870 },
  { x: 967, y: 1834 },
  { x: 968, y: 1802 },
  { x: 974, y: 1775 },
  { x: 1023, y: 1781 },
  { x: 1060, y: 1771 },
  { x: 1093, y: 1780 },
  { x: 1123, y: 1781 },
  { x: 1134, y: 1748 },
  { x: 1130, y: 1710 },
  { x: 1133, y: 1668 },
  { x: 1111, y: 1662 },
  { x: 1073, y: 1691 },
  { x: 1026, y: 1674 },
  { x: 1068, y: 1623 },
  { x: 1083, y: 1565 },
  { x: 1104, y: 1524 },
  { x: 1104, y: 1298 },
  { x: 1084, y: 1278 },
  { x: 983, y: 1261 },
  { x: 980, y: 1228 },
  { x: 988, y: 1180 },
  { x: 957, y: 1136 },
  { x: 950, y: 1098 },
  { x: 947, y: 1021 },
  { x: 970, y: 965 },
  { x: 971, y: 923 },
  { x: 956, y: 906 },
  { x: 960, y: 873 },
  { x: 973, y: 854 },
  { x: 973, y: 816 },
  { x: 960, y: 790 },
  { x: 967, y: 756 },
  { x: 967, y: 720 },
  { x: 974, y: 695 },
  { x: 1023, y: 701 },
  { x: 1060, y: 691 },
  { x: 1122, y: 700 },
  { x: 1134, y: 668 },
  { x: 1130, y: 624 },
  { x: 1133, y: 588 },
  { x: 1112, y: 583 },
  { x: 1073, y: 612 },
  { x: 1027, y: 594 },
  { x: 1068, y: 543 },
  { x: 1083, y: 486 },
  { x: 1105, y: 444 },
  { x: 1095, y: 380 },
  { x: 1140, y: 320 },
  { x: 1218, y: 282 },
  { x: 1290, y: 216 },
  { x: 1407, y: 183 },
  { x: 1556, y: 0 },
  { x: 423, y: 0 },
  { x: 581, y: 257 },
  { x: 723, y: 296 },
  { x: 800, y: 272 },
  { x: 870, y: 366 },
  { x: 921, y: 346 },
  { x: 962, y: 311 },
  { x: 972, y: 397 },
  { x: 961, y: 509 },
  { x: 927, y: 540 },
  { x: 940, y: 612 },
  { x: 883, y: 618 },
  { x: 858, y: 595 },
  { x: 832, y: 616 },
  { x: 810, y: 698 },
  { x: 836, y: 748 },
  { x: 815, y: 828 },
  { x: 837, y: 891 },
  { x: 827, y: 967 },
  { x: 843, y: 1024 },
  { x: 841, y: 1100 },
  { x: 880, y: 1210 },
  { x: 871, y: 1281 },
  { x: 797, y: 1290 },
  { x: 797, y: 1380 },
  { x: 824, y: 1401 },
  { x: 932, y: 1385 },
  { x: 961, y: 1372 },
  { x: 958, y: 1453 },
  { x: 972, y: 1484 },
  { x: 961, y: 1590 },
  { x: 927, y: 1620 },
  { x: 940, y: 1690 },
  { x: 886, y: 1698 },
  { x: 858, y: 1677 },
  { x: 831, y: 1697 },
  { x: 810, y: 1775 },
  { x: 837, y: 1825 },
  { x: 816, y: 1909 },
  { x: 838, y: 1972 },
  { x: 828, y: 2050 },
  { x: 844, y: 2113 },
  { x: 843, y: 2181 },
  { x: 880, y: 2290 },
  { x: 870, y: 2360 },
  { x: 796, y: 2368 },
];

export const obstaclesInBg = {
  bear: {
    starts: [
      { x: 186, y: 491 },
      { x: 186, y: 1571 },
      { x: 1275, y: 2534 },
    ],
    coordinates: [
      { x: 0, y: 131 },
      { x: 18, y: 99 },
      { x: 148, y: 32 },
      { x: 176, y: 37 },
      { x: 166, y: 21 },
      { x: 204, y: 0 },
      { x: 255, y: 0 },
      { x: 287, y: 40 },
      { x: 341, y: 32 },
      { x: 441, y: 123 },
      { x: 355, y: 176 },
      { x: 201, y: 142 },
      { x: 112, y: 179 },
      { x: 13, y: 145 },
    ],
  },
  seal: {
    starts: [{ x: 356, y: 2244 }],
    coordinates: [
      { x: 0, y: 108 },
      { x: 12, y: 85 },
      { x: 101, y: 42 },
      { x: 164, y: 50 },
      { x: 193, y: 32 },
      { x: 179, y: 15 },
      { x: 211, y: 0 },
      { x: 228, y: 14 },
      { x: 232, y: 42 },
      { x: 298, y: 102 },
      { x: 240, y: 138 },
      { x: 134, y: 115 },
      { x: 75, y: 140 },
    ],
  },
  sealReverse: {
    starts: [
      { x: 1346, y: 1747 },
      { x: 1346, y: 670 },
    ],
    coordinates: [
      { x: 0, y: 92 },
      { x: 13, y: 71 },
      { x: 26, y: 64 },
      { x: 25, y: 12 },
      { x: 47, y: 0 },
      { x: 100, y: 26 },
      { x: 164, y: 35 },
      { x: 232, y: 26 },
      { x: 299, y: 88 },
      { x: 240, y: 123 },
      { x: 136, y: 101 },
      { x: 77, y: 125 },
      { x: 8, y: 102 },
    ],
  },
  whale: {
    starts: [{ x: 1163, y: 1274 }],
    coordinates: [
      { x: 0, y: 110 },
      { x: 85, y: 34 },
      { x: 141, y: 28 },
      { x: 240, y: 55 },
      { x: 360, y: 0 },
      { x: 511, y: 125 },
      { x: 424, y: 151 },
      { x: 268, y: 166 },
      { x: 211, y: 150 },
      { x: 120, y: 175 },
      { x: 9, y: 135 },
    ],
  },
  water: {
    starts: [{ x: 95, y: 2676 }],
    coordinates: [
      { x: 0, y: 87 },
      { x: 65, y: 24 },
      { x: 164, y: 17 },
      { x: 232, y: 35 },
      { x: 327, y: 0 },
      { x: 446, y: 44 },
      { x: 510, y: 103 },
      { x: 422, y: 127 },
      { x: 269, y: 142 },
      { x: 211, y: 127 },
      { x: 117, y: 153 },
      { x: 8, y: 111 },
    ],
  },
};

export const obstaclesList = {
  ice1: {
    width: 93,
    height: 63,
    image: Ice1Src,
    coordinates: [
      { x: 0, y: 30 },
      { x: 6, y: 14 },
      { x: 27, y: 10 },
      { x: 46, y: 0 },
      { x: 88, y: 11 },
      { x: 94, y: 22 },
      { x: 86, y: 50 },
      { x: 69, y: 63 },
      { x: 9, y: 56 },
    ],
  },
  ice2: {
    width: 88,
    height: 48,
    image: Ice2Src,
    coordinates: [
      { x: 0, y: 23 },
      { x: 0, y: 12 },
      { x: 18, y: 6 },
      { x: 24, y: 0 },
      { x: 65, y: 0 },
      { x: 82, y: 8 },
      { x: 88, y: 18 },
      { x: 88, y: 29 },
      { x: 75, y: 33 },
      { x: 65, y: 47 },
      { x: 45, y: 48 },
      { x: 21, y: 44 },
      { x: 13, y: 32 },
    ],
  },
  ice3: {
    width: 127,
    height: 103,
    image: Ice3Src,
    coordinates: [
      { x: 0, y: 101 },
      { x: 17, y: 83 },
      { x: 22, y: 50 },
      { x: 34, y: 22 },
      { x: 57, y: 0 },
      { x: 70, y: 14 },
      { x: 75, y: 55 },
      { x: 104, y: 63 },
      { x: 110, y: 84 },
      { x: 127, y: 101 },
    ],
  },
  bear: {
    width: 68,
    height: 51,
    image: BearSrc,
    coordinates: [
      { x: 0, y: 43 },
      { x: 0, y: 35 },
      { x: 4, y: 30 },
      { x: 8, y: 21 },
      { x: 2, y: 10 },
      { x: 18, y: 0 },
      { x: 42, y: 1 },
      { x: 57, y: 28 },
      { x: 63, y: 33 },
      { x: 63, y: 44 },
      { x: 41, y: 51 },
      { x: 18, y: 51 },
    ],
  },
  seal: {
    width: 68,
    height: 57,
    image: SealSrc,
    coordinates: [
      { x: 0, y: 46 },
      { x: 0, y: 37 },
      { x: 12, y: 25 },
      { x: 11, y: 5 },
      { x: 21, y: 0 },
      { x: 30, y: 1 },
      { x: 32, y: 7 },
      { x: 28, y: 12 },
      { x: 68, y: 36 },
      { x: 68, y: 51 },
      { x: 54, y: 58 },
      { x: 47, y: 53 },
      { x: 18, y: 54 },
    ],
  },
  whale: {
    width: 190,
    height: 101,
    image: WhaleSrc,
    coordinates: [
      { x: 0, y: 22 },
      { x: 33, y: 14 },
      { x: 128, y: 32 },
      { x: 147, y: 23 },
      { x: 147, y: 0 },
      { x: 195, y: 28 },
      { x: 164, y: 34 },
      { x: 131, y: 70 },
      { x: 77, y: 77 },
      { x: 83, y: 103 },
      { x: 47, y: 67 },
      { x: 39, y: 93 },
      { x: 29, y: 55 },
    ],
  },
};

//298
